
// @ts-nocheck


export const localeCodes =  [
  "en",
  "zh"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_35e43871",
      load: () => import("#nuxt-i18n/35e43871" /* webpackChunkName: "locale_en_46json_35e43871" */),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_46json_0742749c",
      load: () => import("#nuxt-i18n/0742749c" /* webpackChunkName: "locale_zh_46json_0742749c" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/2a82d681" /* webpackChunkName: "config_i18n_46config_46ts_2a82d681" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      iso: "en-US",
      name: "English",
      language: "en-US",
      files: [
        {
          path: "/var/www/lottobox-livedraw/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      iso: "zh-CN",
      name: "中文",
      language: "zh-CN",
      files: [
        {
          path: "/var/www/lottobox-livedraw/i18n/locales/zh.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "./locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://live.lottobox.cc",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  legacy: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    name: "English",
    language: "en-US",
    files: [
      {
        path: "/var/www/lottobox-livedraw/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    iso: "zh-CN",
    name: "中文",
    language: "zh-CN",
    files: [
      {
        path: "/var/www/lottobox-livedraw/i18n/locales/zh.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/